import { NULL_SERVICE, Service } from '../base/service';

export interface EmptyService extends Service {
  readonly isEmpty: boolean;
}

export const NULL_EMPTY_SERVICE: EmptyService = {
  ...NULL_SERVICE,
  isEmpty: true,
};
